import { OnboardingEntitiesQueryResponse } from '@common/onboarding/query';
import type { FileFormats } from '@common/Transpiler/types';
import { UserTypes } from '@common/UserTypes';

import type { BackEndCodeLanguage, InvitationStatus } from '../graphqlTypes/enums';
import { EditionConfig } from './editionConfigType';

export enum ScheduledMaintenanceKind {
  upgrade = 'upgrade',
  feature_enablement = 'feature_enablement',
  maintenance = 'maintenance'
}
export enum ScheduleStatusTypes {
  ongoing = 'ongoing',
  scheduled = 'scheduled',
  completed = 'completed',
  cancelled = 'cancelled',
  failed = 'failed',
  error = 'error'
}
export type ScheduledMaintenanceType = {
  kind: ScheduledMaintenanceKind;
  fromTime: string;
  toTime: string;
  timezone: string;
  bannerHoursBefore: number;
  customMessage: string;
  status: ScheduleStatusTypes;
  showBanner: boolean;
  createdAt: string;
  updatedAt: string;
};
type MaintainanceType = {
  estimatedTimeRemainingForUpgrade?: number;
  timeLeftMinutes?: number;
  timeLeftHours?: number;
  updateAvailable?: boolean;
  updateTime?: string;
  upgrade_status?: {
    status?: string;
  };
} | null;
export type TrialInfo = {
  billingStarted?: boolean;
  daysLeft?: number;
  billingDetails?: {
    price?: number;
    dimension?: number;
  };
};
// -1 => already have working fabric
// 0 => dont have any fabric
// 1 => fabric id, fabric(unconfigured)

export enum UserFabricStatusKnownStatus {
  AlreadyHaveFabric = -1,
  NoFabric = 0
}

export enum UserState {
  active = 'active',
  inactive = 'inactive',
  rejected = 'rejected'
}

export type UserFabricStatus = UserFabricStatusKnownStatus | number;

export type UserDetails = {
  id: string;
  email: string;
  type?: UserTypes;
  fabric?: UserFabricStatus;
  created?: number;
  trialInfo?: TrialInfo;
  onboardingDetail?: NonNullable<OnboardingEntitiesQueryResponse['User']>['onboardingEntities'];
  userOnboardingDetails?: { profession?: string; industry?: string };
  userState?: UserState;
  invitationStatus?: InvitationStatus;
};

export type EnabledTranspilers = {
  transpiler?: {
    targetLanguage: BackEndCodeLanguage[];
    transpilerType: FileFormats;
  }[];
};

export type AppMetadataProviderType = {
  user?: UserDetails;
  loggedInUserData?: UserDetails & { firstName?: string; lastName?: string };
  cookieAccepted: boolean;
  globalConfig: { [key: string]: unknown };
  unsecuredConfig: { [key: string]: unknown };
  maintenanceUpdateInfo?: MaintainanceType;
  setMaintenanceUpdateInfo: (maintenanceUpdateInfo?: MaintainanceType) => void;
  editionConfig: EditionConfig;
  enabledTranspilers: EnabledTranspilers;
  shareUrl: string | null;
  replayUrl: string | null;
};
